import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectLinkPreviewIsEnabledOption')(function selectLinkPreviewIsEnabledOption(isLinkPreviewEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isLinkPreviewEnabled;
}));
//# sourceMappingURL=selectLinkPreviewIsEnabledOption.js.map